import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/styles/sidebar.css";

const MOBILE_BREAKPOINT = 1024;
const SIDEBAR_WIDTH = 240;

const AdminSidebar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const isSmall = window.innerWidth <= MOBILE_BREAKPOINT;
    setIsMobileOrTablet(isSmall);
    setIsOpen(!isSmall);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const isSmall = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileOrTablet(isSmall);
      setIsOpen((prev) => (isSmall ? false : prev ?? true));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobileOrTablet) {
      setIsOpen(false);
    }
  }, [location.pathname, isMobileOrTablet]);

  const closeIfMobile = () => {
    if (isMobileOrTablet) setIsOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    "glass-link" + (isActive ? " active" : "");

  return (
    <>
      {isMobileOrTablet && (
        <div className="mobile-toggle-wrap-fixed">
          <button
            className="mobile-toggle"
            onClick={() => setIsOpen((v) => !v)}
            aria-expanded={isOpen}
            aria-label={isOpen ? "Close admin menu" : "Open admin menu"}
          >
            <span className="ms-2">{isOpen ? "X Close" : "Menu"}</span>
          </button>
        </div>
      )}

      <aside
        className={`glass-sidebar app-sidebar ${isOpen ? "open" : "closed"} ${
          isMobileOrTablet ? "mobile" : "desktop"
        }`}
        style={{ width: SIDEBAR_WIDTH }}
        aria-hidden={!isOpen && isMobileOrTablet}
      >
        <div className="glass-brand">
          <i className="bi bi-shield-lock-fill"></i>
          <span>Admin Console</span>
        </div>

        <nav aria-label="Admin navigation" className="glass-nav">
          <ul className="menu-list show">
            <li>
              <NavLink
                to="/adminLayout/admin-org-approvals"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Organization Approvals
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/adminLayout/admin-Event-approvals"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Event Approvals
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/adminLayout/admin-doctor-approvals"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Doctor Approvals
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/adminLayout/CpdCertPrint"
                className={linkClass}
                onClick={closeIfMobile}
              >
                CPD Certificate Print
              </NavLink>
            </li>
            <li className="nav-item mb-2">
              <NavLink to="/adminLayout/upcoming-form"  
                className={linkClass}
                onClick={closeIfMobile}>
                  Update Upcoming events 
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/adminLayout/docPrint"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Sample Certificate
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/adminLayout/failed-emails"
                className={linkClass}
                onClick={closeIfMobile}
              >
                Show Failed Emails
              </NavLink>
            </li>
          </ul>
        </nav>
      </aside>

      {isMobileOrTablet && isOpen && (
        <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default AdminSidebar;
